'use strict';

import ProfileButton from "../components/ProfileButton";
import OrdersButton from "../components/OrdersButton";
import NotificationsButton from "../components/NotificationsButton";
import useAuth from "~/hooks/useAuth";
import useBeardCounts from "../hooks/useBeardCounts";
import withQueryClient from "~/helpers/withQueryClient";

function HeaderAccountWidget() {
    const { data: authData, isLoggedIn, isLoading } = useAuth()
    const { data: counts } = useBeardCounts()

    const notificationsCount = counts.notifications
    const ordersCount = counts.subscriptions + counts.requests + counts.flights
    const hasNewOrders = [counts.subscriptions_unviewed, counts.requests_unviewed, counts.flights_unviewed].some(e => e > 0)

    function handleLogout(event) {
        authAction.logout(event, true)
    }

    function handleShowOrders() {
        raiseEvent('hideNotificationsBeard');
        raiseEvent('showOrdersBeard');
    }

    function handleShowNotifications() {
        raiseEvent('hideOrdersBeard');
        raiseEvent('showNotificationsBeard');
    }

    if (isLoading)
        return null

    if (isLoggedIn) {
        return (
            <div className="header__logger-menu">
                <ProfileButton name={authData.name} showCompanyLink={authData.hasCompany} onLogout={handleLogout} />
                <OrdersButton count={ordersCount} active={hasNewOrders} onPress={handleShowOrders} />
                <NotificationsButton count={notificationsCount} onPress={handleShowNotifications} />
            </div>
        )
    }

    return (
        <div className="header__login-drop">
            <a href="#reactAuthModal" data-mode="login" data-fancybox="auth">{__('menu.login')}</a>
            /
            <a href="#reactAuthModal" data-mode="select" data-fancybox="select">{__('menu.register')}</a>
        </div>
    )
}

window.HeaderAccountWidget = withQueryClient(HeaderAccountWidget)
